import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

const DELETE_EVENT_TICKET = gql`
  mutation DeleteEventTicket($id: Int!) {
    deleteEventTicket(id: $id)
  }
`;

export function useDeleteEventTicket() {
  const [deleteEventTicketMutation, { loading, error }] =
    useMutation(DELETE_EVENT_TICKET);

  const deleteEventTicket = useCallback(
    async (ticketId) => {
      const response = await deleteEventTicketMutation({
        variables: { id: Number(ticketId) },
      });
      return response;
    },
    [deleteEventTicketMutation]
  );

  return { deleteEventTicket, loading, error };
}
